import Immutable from 'immutable';
import without from 'lodash/without';
import { getFilters } from "../../common/config/filters";
import enhanceFilters from "../../common/utils/enhanceFilters";
import { valuedFilters } from "../../common/utils/filters";
import { resolveSortFromFilters } from "../../common/utils/sorting";
import { DISCOVER, SEARCH } from "../constants/perspectives";
export function resolveDiscoverHeadingText(_ref) {
  let {
    filters,
    featureFlags
  } = _ref;
  if (filters.get('product')) {
    return "Explore apps for ".concat(getFilters({
      featureFlags
    }).getIn(['product', 'customFilters', filters.get('product'), 'label']));
  }
  return 'Explore apps for Atlassian products';
}
export function resolveSearchHeadingText(_ref2) {
  let {
    filters,
    featureFlags
  } = _ref2;
  const currentSort = resolveSortFromFilters({
    filters
  });
  const productFilter = getFilters({
    featureFlags
  }).get('product').get('customFilters').get(filters.get('product'));
  const moreFilters = filters.get('moreFilters');
  const topVendorFilter = moreFilters ? moreFilters.includes('topVendor') : false;
  const baseTitle = without([currentSort && currentSort.get('title'), filters.get('category') || productFilter && productFilter.get('label')], undefined).join(' ');
  if (baseTitle.length) {
    return "".concat(baseTitle, " apps").concat(topVendorFilter ? ' from Top Vendors' : '');
  } else if (topVendorFilter) {
    return 'Apps from Top Vendors';
  } else if (valuedFilters(filters).size) {
    return 'Search results';
  } else {
    return 'Search for apps';
  }
}
function resolveTitle(_ref3) {
  let {
    filters,
    perspectiveKey,
    featureFlags
  } = _ref3;
  switch (perspectiveKey) {
    case SEARCH:
      return resolveSearchHeadingText({
        filters,
        featureFlags
      });
    case DISCOVER:
      return resolveDiscoverHeadingText({
        filters,
        featureFlags
      });
    default:
      console.error("Invalid perspective provided '".concat(perspectiveKey, " - cannot resolve title"));
  }
}
function resolveMetaDescription(_ref4) {
  let {
    filters,
    perspectiveKey,
    featureFlags
  } = _ref4;
  const productFilter = getFilters({
    featureFlags
  }).get('product').get('customFilters').get(filters.get('product'));
  const products = productFilter ? "Atlassian ".concat(productFilter.get('label')) : 'Jira, Confluence, Bitbucket & other Atlassian products';
  const currentSort = resolveSortFromFilters({
    filters
  });
  const sortLabel = currentSort ? currentSort.get('label').toLowerCase() : undefined;
  const defaultPrefix = perspectiveKey === SEARCH ? 'Find' : 'Browse the top';
  const filterPrefix = sortLabel ? "Find the ".concat(sortLabel) : defaultPrefix;
  const moreFilters = filters.get('moreFilters');
  const topVendorFilter = moreFilters ? moreFilters.includes('topVendor') : false;
  const prefix = topVendorFilter ? 'Find Top Vendor' : filterPrefix;
  return "".concat(prefix, " apps, add-ons, plugins & integrations for ").concat(products, ". Free 30-day trial for all apps.");
}
export function resolveMeta(_ref5) {
  let {
    filters,
    perspectiveKey,
    featureFlags
  } = _ref5;
  const enhancedFilters = enhanceFilters(filters, featureFlags);
  return Immutable.Map({
    title: resolveTitle({
      filters: enhancedFilters,
      perspectiveKey,
      featureFlags
    }),
    description: resolveMetaDescription({
      filters: enhancedFilters,
      perspectiveKey,
      featureFlags
    })
  });
}